// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper-LoMxDO,.input-wrapper-LoMxDO span{width:100%}.error-wrapper-w1aOxa .semi-input-wrapper{border:1px solid #ddd}.error-content-tu8UMi{height:20px}.error-float-hdNho0{width:100%;position:absolute}.error-text-TauGQ_{color:#ddd;padding-top:2px;padding-left:12px;font-size:12px;position:absolute}.textarea-pd-P08Qos,.inputting-HcW7hV textarea{padding-bottom:0}.input-blur-wE0bFB textarea{text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;padding-bottom:0;display:-webkit-box;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `input-wrapper-LoMxDO`,
	"inputWrapper": `input-wrapper-LoMxDO`,
	"error-wrapper": `error-wrapper-w1aOxa`,
	"errorWrapper": `error-wrapper-w1aOxa`,
	"error-content": `error-content-tu8UMi`,
	"errorContent": `error-content-tu8UMi`,
	"error-float": `error-float-hdNho0`,
	"errorFloat": `error-float-hdNho0`,
	"error-text": `error-text-TauGQ_`,
	"errorText": `error-text-TauGQ_`,
	"textarea-pd": `textarea-pd-P08Qos`,
	"textareaPd": `textarea-pd-P08Qos`,
	"inputting": `inputting-HcW7hV`,
	"input-blur": `input-blur-wE0bFB`,
	"inputBlur": `input-blur-wE0bFB`
};
export default ___CSS_LOADER_EXPORT___;
